import { ActionType } from '@glovo/multimedia'
import type { Provider } from '@glovo/multimedia'

export function makePartnersProvider({ url }: { url: string }): Provider {
  const regex = /^https:\/\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]+/i

  return {
    name: 'partners',
    getImageUrl: ({ source }: { source: string }) => source,
    canHandle(actionType: ActionType, source: string) {
      if (actionType === ActionType.GetImage) {
        return regex.test(source) && !source.startsWith(url)
      }

      return false
    },
  }
}
